module.exports = __webpack_public_path__ + "static/media/yuyu.4e3e097d.svg";